// Universal directions utility
import { Shop } from "../types/Shop";

export const getDirectionsToShop = (shop: Shop): void => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${shop.coordinates[0]},${shop.coordinates[1]}`;

    // Detect if user is on mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
        // Mobile: Navigate in same tab (will likely open native Maps app)
        window.location.href = url;
    } else {
        // Desktop: Open in new tab so user doesn't lose your site
        window.open(url, '_blank');
    }
};